import { createFilledIcon } from "../createIcon";

export const SendFilledIcon = createFilledIcon(
  <>
    <path d="M16.8909 9.09507L4.94261 2.63545C4.04045 2.14748 3.02644 3.06428 3.4209 4.01065L5.42667 8.86058C5.50542 9.04852 5.69007 9.16922 5.89382 9.16667H8.33331C8.79355 9.16667 9.16665 9.53976 9.16665 10C9.16665 10.4602 8.79355 10.8333 8.33331 10.8333H5.89382C5.69003 10.8308 5.50508 10.9522 5.42635 11.1401L3.42079 16.0923C3.02748 17.0369 4.0401 17.9526 4.94056 17.4656L16.8912 11.0066C17.6507 10.5964 17.6505 9.50638 16.8909 9.09507Z" />
  </>,
  "SendFilledIcon"
);
